<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner box">
      <div class="mianbox">
        <div class="top clearfix">
          <div class="fl" style="text-align: center">
            <div
              style="
                border-radius: 50%;
                overflow: hidden;
                margin-bottom: 5px;
                width: 115px;
                height: 115px;
              "
            >
              <img
                v-if="personaldata.avatar == ' '"
                src="../../assets/user.png"
                alt=""
              />
              <img
                v-else
                :src="personaldata.avatar"
                alt=""
                style="width: 100%; height: 100%"
              />
            </div>
            <!-- <el-button size="mini">更换头像</el-button> -->
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
          <div class="fl two">
            <div class="first">账号：{{ accountnumber }}</div>
            <div style="height: 60px">
              密码：<span>***********</span>
              <el-button
                style="margin-left: 20px"
                size="mini"
                @click="dialogFormVisible = true"
                >修改密码</el-button
              >
            </div>
          </div>
          <div class="fr buttom" style="padding-right: 60px; margin-top: 20px">
            <div style="padding-bottom: 20px">
              <el-button size="mini" @click="$router.push('/person/news')"
                >消息</el-button
              >
            </div>
            <div>
              <el-button size="mini" @click="handleOff">退出登录</el-button>
            </div>
          </div>
        </div>
        <div class="bottom clearfix">
          <div class="fl">
            <p>
              个人信息<el-button
                type="text"
                style="margin-left: 40px"
                @click="isRevise"
                >修改</el-button
              >
            </p>
            <div v-if="isShow" class="info">
              <div><span>姓名：</span> {{ personaldata.user_nicename }}</div>
              <div>
                <span>性别：</span> {{ personaldata.sex == 0 ? "女" : "男" }}
              </div>
              <div>
                <span>生日：</span>
                {{
                  personaldata.birthday == null ? "未知" : personaldata.birthday
                }}
              </div>
              <!-- <div><span>电话：</span> {{ personaldata.mobile }}</div> -->
              <div>
                <span>民族：</span>
                {{ personaldata.nation == null ? "未知" : personaldata.nation }}
              </div>
              <div>
                <span>籍贯： </span
                >{{
                  personaldata.hometown == null ? "未知" : personaldata.hometown
                }}
              </div>
              <div>
                <span>最高学历：</span>
                {{
                  personaldata.degree == 0
                    ? "大专"
                    : personaldata.degree == 1
                    ? "本科"
                    : personaldata.degree == 2
                    ? "硕士"
                    : personaldata.degree == 3
                    ? "博士"
                    : "未知"
                }}
              </div>
              <div>
                <span>毕业院校：</span>
                {{
                  personaldata.school_name == null
                    ? "未知"
                    : personaldata.school_name
                }}
              </div>
            </div>
            <el-form
              label-position="left"
              label-width="80px"
              :model="personalform"
              v-else
            >
              <el-form-item label="姓名">
                <el-input v-model="personalform.user_nicename"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="personalform.sex" placeholder="请选择性别">
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="生日">
                <el-date-picker
                  v-model="personalform.birthday"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="电话">
                <el-input v-model="personalform.mobile"></el-input>
              </el-form-item> -->
              <el-form-item label="民族">
                <el-input v-model="personalform.nation"></el-input>
              </el-form-item>
              <el-form-item label="籍贯">
                <el-input v-model="personalform.hometown"></el-input>
              </el-form-item>
              <el-form-item label="最高学历">
                <el-select
                  v-model="personalform.degree"
                  placeholder="请选择学历"
                >
                  <el-option label="大专" value="0"></el-option>
                  <el-option label="本科" value="1"></el-option>
                  <el-option label="硕士" value="2"></el-option>
                  <el-option label="博士" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="毕业院校">
                <el-input v-model="personalform.school_name"></el-input>
              </el-form-item>
              <el-button
                size="small"
                type="primary"
                round
                style="width: 200px"
                @click="handleSive"
                >保存</el-button
              >
            </el-form>
          </div>
          <div class="fr">
            <p>
              教学信息
              <el-button type="text" style="margin-left: 40px" @click="isChange"
                >修改</el-button
              >
            </p>
            <div v-if="isShow2" class="info">
              <div><span>学校：</span>{{ schoolname }}</div>
              <div><span>职务：</span>{{ schooljob }}</div>
              <div><span>科目：</span> {{ personaldata.subject }}</div>
              <div>
                <span>管理班级：</span>
                <span
                  style="color: #868282"
                  v-for="(item, index) in classdata"
                  :key="index"
                >
                  {{ item.grade_name + item.class_name }} |
                </span>
              </div>
              <div>
                <span>任课班级：</span>
                <span
                  style="color: #868282"
                  v-for="(item, index) in teachclassdata"
                  :key="index"
                >
                  {{
                    item.grade_name +
                    item.class_name +
                    "(" +
                    item.subject_name +
                    ")"
                  }}
                  |
                </span>
              </div>
              <div><span>教师简介：</span> {{ personaldata.profile_text }}</div>
              <div><span>教师寄语：</span> {{ personaldata.wishes }}</div>
            </div>

            <el-form
              label-position="left"
              label-width="80px"
              :model="personalform"
              v-else
              style="width: 400px"
            >
              <div class="info">
                <div><span>学校：</span>{{ schoolname }}</div>
                <div><span>职务：</span>{{ schooljob }}</div>
                <div><span>科目：</span> {{ personaldata.subject }}</div>
                <div>
                  <span>管理班级：</span>
                  <span
                    style="color: #868282"
                    v-for="(item, index) in classdata"
                    :key="index"
                  >
                    {{ item.grade_name + item.class_name }} |
                  </span>
                </div>
                <div>
                  <span>任课班级：</span>
                  <span
                    style="color: #868282"
                    v-for="(item, index) in teachclassdata"
                    :key="index"
                  >
                    {{
                      item.grade_name +
                      item.class_name +
                      "(" +
                      item.subject_name +
                      ")"
                    }}
                    |
                  </span>
                </div>
              </div>

              <!-- <el-form-item label="学校">
                <el-input disabled v-model="personalform.school" :placeholder="personalform.school"></el-input>
              <el-form-item label="学校">
                <el-input readonly v-model="schoolname"></el-input>
              </el-form-item>
              <el-form-item label="职务">
                <el-input readonly v-model="personalform.job"></el-input>
              </el-form-item>
              <el-form-item label="科目">
                <el-input readonly v-model="personalform.subject"></el-input>
              </el-form-item>
              <el-form-item label="教材">
                <el-input readonly v-model="personalform.edition"></el-input>
                <el-input readonly v-model="personaldata.subject"></el-input>
              </el-form-item>
               <el-form-item label="教材">
                <el-input readonly v-model="personalform.edition"></el-input>
              </el-form-item> -->
              <!-- <el-form-item label="管理班级">
                <el-input readonly v-model="personalform.manageClass"></el-input>
              </el-form-item>
              <el-form-item label="任课班级">
                <el-input readonly v-model="personalform.teachClass"></el-input>
              </el-form-item> -->

              <el-form-item label="教师简介">
                <el-input
                  type="textarea"
                  v-model="personalform.profile_text"
                ></el-input>
              </el-form-item>
              <el-form-item label="教师寄语">
                <el-input
                  type="textarea"
                  v-model="personalform.wishes"
                ></el-input>
              </el-form-item>
              <el-button
                size="small"
                type="primary"
                round
                style="width: 200px"
                @click="handleSive2"
                >保存</el-button
              >
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改密码弹出框 -->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" class="table">
      <div class="clearfix li">
        <p class="titlename fl"><span class="fr">手机号：</span></p>
        <div class="fr inputForm">
          <el-input
            clearable
            readonly
            placeholder="请输入手机号"
            v-model="ruleForm.phone"
            size="small"
          >
          </el-input>
        </div>
      </div>

      <div class="clearfix li">
        <p class="titlename fl"><span class="fr">验证码：</span></p>
        <div class="fr inputForm">
          <el-input
            clearable
            placeholder="请输入验证码"
            v-model="ruleForm.code"
            size="small"
            @blur="codeform(ruleForm.code)"
            @input="codeform(ruleForm.code)"
          >
          </el-input>
          <div class="tip">{{ codeerror }}</div>
        </div>
        <el-button
          style="position: absolute; right: 60px; height: 40px; width: 20%"
          size="small"
          :disabled="disabled"
          type="primary"
          @click="acquire"
          >{{ codenum }}</el-button
        >
      </div>

      <div class="clearfix li">
        <p class="titlename fl"><span class="fr">新密码：</span></p>
        <div class="fr inputForm">
          <el-input
            clearable
            type="password"
            placeholder="请输入新密码"
            v-model="ruleForm.password"
            size="small"
            @blur="passwordform(ruleForm.password)"
            @input="passwordform(ruleForm.password)"
          >
          </el-input>
          <div class="tip">{{ passworderror }}</div>
        </div>
      </div>

      <div class="clearfix li">
        <p class="titlename fl"><span class="fr">确认密码：</span></p>
        <div class="fr inputForm">
          <el-input
            clearable
            type="password"
            placeholder="请再输入新密码"
            v-model="ruleForm.checkPass"
            size="small"
            @blur="checkPassform(ruleForm.checkPass)"
            @input="checkPassform(ruleForm.checkPass)"
          >
          </el-input>
          <div class="tip">{{ checkPasserror }}</div>
        </div>
      </div>

      <div class="clearfix">
        <el-button
          type="primary"
          class="fr"
          style="width: 80%; margin-top: 20px"
          @click="handlechange"
          >确认修改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from "../../api/eventBus";
import URL from "../../api/index";
import { rand } from "../../api/http";
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "120px",
      schooljob: "",
      isShow: true,
      isShow2: true,
      input: "",
      // 个人信息
      personalform: {
        token: "",
        // 用户请求token
        user_nicename: "",
        // 姓名
        sex: "",
        // 性别
        birthday: "",
        // 生日
        mobile: "",
        // 电话
        nation: "",
        // 名族
        hometown: "",
        // 籍贯
        degree: "",
        // 最高学历：1专科，2本科，3硕士，4博士
        school_name: "",
        // 毕业院校
        avatar: "",
        // 头像
        profile_text: "",
        // 教师简介
        wishes: "",
        // 教师寄语
        user_id: "",
        // 教师id
      },
      accountnumber: "",
      ruleForm: {
        phone: "",
        password: "",
        checkPass: "",
        code: "",
      },
      disabled: false,
      codenum: "获取验证码",
      countdown: 60,
      message: "",
      //错误提示
      codeerror: "",
      passworderror: "",
      checkPasserror: "",
      //正确判定
      iscodeerror: false,
      ispassworderror: false,
      ischeckPasserror: false,

      aliyunOssToken: "",
      // 个人信息
      personaldata: "",
      // 班级列表
      classdata: "",
      teachclassdata: [],
      schoolname: "",
    };
  },
  components: { top, navMenu },
  created() {},
  watch: {
    value1(val) {
      console.log(val);
    },
  },
  mounted() {
    this.schooljob = JSON.parse(localStorage.getItem("loginInfo")).level;
    this.accountnumber = JSON.parse(localStorage.getItem("loginInfo")).mobile;
    if (localStorage.getItem("classdata")) {
      this.classdata = JSON.parse(localStorage.getItem("classdata"));
      this.schoolname = JSON.parse(
        localStorage.getItem("classdata")
      )[0].school_name;
    }
    this.handleTeachclass();
    this.getOssToken();
    this.user_details();
    this.getMasterschool();
    this.getMasterclass();
  },
  methods: {
    // 任课班级
    handleTeachclass() {
      var that = this;
      var data = { token: JSON.parse(localStorage.getItem("loginInfo")).token };
      this.$post(URL.Getteacherclass, data).then(function (res) {
        console.log(res.result);
        // if (res.result) {
        that.teachclassdata = res.result;
        // }
      });
    },
    isRevise() {
      this.isShow = false;
    },
    isChange() {
      this.isShow2 = false;
    },
    // 个人表单修改个人信息
    handleSive() {
      var that = this;
      that.isShow = true;
      that.personalform.token = JSON.parse(
        localStorage.getItem("loginInfo")
      ).token;
      // console.log(this.personalform)
      that.$post(URL.edit_teacherinfo, that.personalform).then(function (res) {
        that.user_details();
      });
    },
    // 学校表单修改个人信息
    handleSive2() {
      var that = this;
      that.isShow2 = true;
      that.personalform.token = JSON.parse(
        localStorage.getItem("loginInfo")
      ).token;
      // console.log(this.personalform)
      that.$post(URL.edit_teacherinfo, that.personalform).then(function (res) {
        that.user_details();
      });
    },
    handleOff() {
      this.$confirm("确认要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.getRecordRjw(
            JSON.parse(localStorage.getItem("loginInfo")),
            JSON.parse(localStorage.getItem("data_traceid"))
          );
          localStorage.clear();
          this.$router.push("/");
        })
        .catch(() => {});
    },
    // 数据上报
    getRecordRjw(hh, xx) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "user_logout",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: xx,
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "退出了教师工作台",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    // 获取个人信息
    user_details() {
      var that = this;
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
      };
      this.$post(URL.user_details, data).then(function (res) {
        console.log(res.result.teach_class);
        eventBus.$emit("avatar", res.result.avatar);
        // JSON.parse(localStorage.getItem("loginInfo")).avatar=res.result.avatar
        that.personaldata = res.result;
        // 姓名
        that.personalform.user_nicename = that.personaldata.user_nicename;
        // 性别
        that.personalform.sex = that.personaldata.sex;
        // 生日
        that.personalform.birthday = that.personaldata.birthday;
        // 电话
        that.ruleForm.phone = that.personaldata.mobile;
        that.personalform.mobile = that.personaldata.mobile;
        // 民族
        that.personalform.nation = that.personaldata.nation;
        // 籍贯
        that.personalform.hometown = that.personaldata.hometown;
        // 最高学历：1专科，2本科，3硕士，4博士
        that.personalform.degree =
          that.personaldata.degree && that.personaldata.degree.toString();
        // 毕业院校
        that.personalform.school_name = that.personaldata.school_name;
        // 头像
        that.personalform.avatar = that.personaldata.avatar;
        // 教师简介
        that.personalform.profile_text = that.personaldata.profile_text;
        // 教师寄语
        that.personalform.wishes = that.personaldata.wishes;
        // 教师id
        that.personalform.user_id = that.personaldata.user_id;
        console.log(that.personalform);
      });
    },
    // 获取学校信息
    getMasterschool() {
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        school_id: 7,
      };
      this.$post(URL.get_school_info, data).then((res) => {
        console.log(res);
      });
    },
    // 获取管理班级列表
    getMasterclass() {
      var data = { token: JSON.parse(localStorage.getItem("loginInfo")).token };
      this.$post(URL.getMasterclass, data).then((res) => {
        if (res.result) {
          console.log(res.result);
          this.schooldata = res.result[0];
          this.classdata = res.result;
          eventBus.$emit("classdata", this.classdata);
          localStorage.setItem("classdata", JSON.stringify(this.classdata));
        }
      });
    },
    //获取上传通行证
    getOssToken() {
      var _self = this;
      this.$get(
        "https://api.rujiaowang.net/netlearn/Common/album_get_oss_key"
      ).then(function (res) {
        _self.aliyunOssToken = res;
      });
    },
    // 头像修改
    beforeAvatarUpload(file) {
      console.log(file.type);
      const ispng = file.type === "image/png";
      const isJPG = file.type === "image/jpeg";

      if (!ispng && !isJPG) {
        this.$message.error("上传头像图片只能是jpeg和png格式!");
        return false;
      }

      var filename = file.name;
      var getSuffix = function (filename) {
        // console.log(filename)
        var pos = filename.lastIndexOf(".");
        var suffix = "";
        if (pos != -1) {
          suffix = filename.substring(pos);
        }
        return suffix;
      };
      filename =
        new Date().getTime() +
        Math.ceil(Math.random() * 10000) +
        getSuffix(filename);
      // console.log(filename)
      var _self = this;
      var formData = new FormData();
      //注意formData里append添加的键的大小写
      formData.append(
        "key",
        _self.aliyunOssToken.dir + "school_admin/personal" + filename
      ); //存储在oss的文件路径
      formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid); //accessKeyId
      formData.append("policy", _self.aliyunOssToken.policy); //policy
      formData.append("Signature", _self.aliyunOssToken.signature); //签名
      //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
      formData.append("callback", _self.aliyunOssToken.callback); //policy
      formData.append("file", file);
      formData.append("success_action_status", 200); //成功后返回的操作码
      var url = _self.aliyunOssToken.host;
      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          // console.log(data.filename)
          _self.edit_teacherinfo(data.filename);
        },
        error: function (data) {},
      });
    },
    // 头像修改个人信息
    edit_teacherinfo(a) {
      var that = this;
      that.personalform.token = JSON.parse(
        localStorage.getItem("loginInfo")
      ).token;
      that.personalform.avatar = a;
      that.$post(URL.edit_teacherinfo, that.personalform).then(function (res) {
        console.log(res);
        that.user_details();
      });
    },
    // 获取验证码
    acquire() {
      var data_code = {
        mobile: JSON.parse(localStorage.getItem("loginInfo")).mobile,
      };
      this.$post(URL.getvcode, data_code).then((res) => {
        console.log(res);
        if (res.state == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.timer();
        } else {
          this.$message(res.msg);
        }
      });
    },
    timer() {
      if (this.countdown > 0) {
        this.disabled = true;
        this.countdown--;
        this.codenum = "重新发送(" + this.countdown + ")";
        setTimeout(this.timer, 1000);
      } else {
        this.countdown = 0;
        this.codenum = "获取验证码";
        this.disabled = false;
      }
    },
    // 验证码校验
    codeform(val) {
      var data_code = {
        mobile: JSON.parse(localStorage.getItem("loginInfo")).mobile,
        code: val,
      };
      this.$post(URL.checkcode, data_code).then((res) => {
        console.log(res);
        if (res.state == 0) {
          this.codeerror = "";
          this.iscodeerror = true;
        } else {
          this.iscodeerror = false;
          this.codeerror = res.msg;
        }
      });
    },
    // 密码
    passwordform(val) {
      var re = /^[\w!-@#$%^&*]{6,20}$/;
      if (val === "") {
        this.passworderror = "密码不能为空";
        this.ispassworderror = false;
      } else {
        if (re.test(val)) {
          this.passworderror = "";
          this.ispassworderror = true;
        } else {
          this.ispassworderror = false;
          this.passworderror = "请输入6到20位字母或数字的密码";
        }
      }
    },
    // 新密码
    checkPassform(val) {
      // var re = /^[\w!-@#$%^&*]{6,20}$/;
      if (val === "") {
        this.checkPasserror = "请再次输入密码";
        this.ispassworderror = false;
      } else {
        if (val !== this.ruleForm.password) {
          this.checkPasserror = "两次输入密码不一致";
          this.ispassworderror = false;
        } else {
          this.checkPasserror = "";
          this.ischeckPasserror = true;
        }
      }
    },
    // 密码修改
    handlechange() {
      var data = {
        mobile: this.ruleForm.phone,
        code: this.ruleForm.code,
        pwd1: this.ruleForm.password,
        pwd2: this.ruleForm.checkPass,
      };
      if (this.ischeckPasserror) {
        var a = true;
      } else {
        this.passworderror = "密码不能为空";
      }
      if (this.ispassworderror) {
        var b = true;
      } else {
        this.checkPasserror = "请再次输入密码";
      }
      if (this.iscodeerror) {
        var c = true;
      } else {
        this.codeerror = "验证码不能为空";
      }
      if (a && b && c) {
        this.$post(URL.getreset, data).then((res) => {
          console.log(res);
          if (res.state == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogFormVisible = false;
          } else {
            this.$message(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.box {
  background-color: #fff;
  margin-top: 15px;
  border-radius: 8px;
  .mianbox {
    padding-bottom: 40px;
    p {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 20px;
      // border-left: 4px solid #3b8bfd;
      // padding-left: 10px;
    }
  }
  .top {
    background-color: #3b8bfd;
    padding: 40px 0;
    padding-bottom: 20px;
    margin-bottom: 40px;
    padding-left: 200px;
    // border-bottom: 1px solid #f4f4f4;
  }
  .two {
    color: #fff;
    margin-left: 60px;
    .first {
      margin-top: 20px;
      margin-bottom: 40px;
    }
  }
  .info {
    width: 400px;

    div {
      margin-bottom: 30px;
      color: rgb(134, 130, 130);
      span {
        color: #000;
      }
    }
  }
  .bottom {
    padding: 0 60px 0 200px;
    .el-input /deep/ .el-input__inner {
      height: 30px !important;
    }
    .el-select /deep/ .el-input__inner {
      height: 30px !important;
    }
  }
}

.el-form-item {
  margin-bottom: 25px !important;
}
// .buttom /deep/ .el-button--primary {
//   color: #000 !important;
//   background-color: #fff !important;
// }
.buttom /deep/ .el-button {
  width: 100px !important;
  font-size: 14px;
}
.el-dialog__wrapper/deep/.el-dialog {
  margin-top: 30vh !important;
  width: 30% !important;
}
.el-dialog__wrapper /deep/ .el-dialog__body {
  padding-right: 60px !important;
}
.el-dialog__wrapper /deep/.el-input-group__append {
  width: 66px !important;
  background-color: #409eff !important;
  color: #fafafa !important;
  border: 1px solid #409eff !important;
  text-align: center !important;
}
.table {
  .li {
    margin-top: 5px;
    &:first-child {
      margin-bottom: 29px;
    }
  }
  .titlename {
    line-height: 40px;
    width: 19%;
    font-size: 16px;
  }
  .inputForm {
    width: 80%;
    /deep/ .el-input--small .el-input__inner {
      line-height: 40px;
      height: 40px;
    }
    .tip {
      font-size: 12px;
      color: red;
      height: 24px;
      line-height: 24px;
    }
  }
}
</style>